// 最新情報（NEWS）一覧
// 新しい情報を上に表示します。日付・タイトル・リンクを自由に変更・追加・削除できます。
// link は空文字 "" にするとリンクなし、URLを入れるとリンク付きになります。
export const newsItems = [
  {
    date: '2026.9.6',
    title: '全出演者公開',
    link: '',
  },
  {
    date: '2026.08.26',
    title: '白柏寿大 出演決定・先行応援席情報公開',
    link: '',
  },
  {
    date: '2026.08.23',
    title: '登場人物表を更新しました。',
    link: '',
  },
  {
    date: '2026.07.30',
    title: '公演サイト公開',
    link: '',
  },
];